export type CultivarSaveSection =
  | "field"
  | "fertilizer"
  | "pesticides"
  | "irrigation"
  | "fuelUse"
  | "landUse";

const SAVE_REMINDER_MESSAGES: Record<CultivarSaveSection, string> = {
  field: "Please click the Update button to save your field details.",
  fertilizer: `Click “+” to add fertilizer entries, or edit existing entries as needed. Your changes are only saved when you click “Save/Update” at the bottom of the page.`,
  pesticides: `Click “+” to add pesticide entries, or edit existing entries as needed. Your changes are only saved when you click “Save/Update” at the bottom of the page.`,
  irrigation: `Click “+” to add irrigation entries, or edit existing entries as needed. Your changes are only saved when you click “Save/Update” at the bottom of the page.`,
  fuelUse: `Click “+” to add fuel use entries, or edit existing entries as needed. Your changes are only saved when you click “Save/Update” at the bottom of the page.`,
  landUse: `Select "Yes" if land use data is available, then use "+" to add or update entries. Don't forget to hit "Save/Update" — entries won't be saved until then.`
};

export const DELETE_CONFIRM_MESSAGES: Record<Exclude<CultivarSaveSection, "field">, string> = {
  fertilizer: `Delete this fertilizer entry? It won’t be permanently deleted until you click “Save/Update” at the bottom of the page.`,
  pesticides: `Delete this pesticide entry? It won’t be permanently deleted until you click “Save/Update” at the bottom of the page.`,
  irrigation: `Delete this irrigation entry? It won’t be permanently deleted until you click “Save/Update” at the bottom of the page.`,
  fuelUse: `Delete this fuel use entry? It won’t be permanently deleted until you click “Save/Update” at the bottom of the page.`,
  landUse: `Delete this land use entry? It won’t be permanently deleted until you click “Save/Update” at the bottom of the page.`
};

type CultivarSaveReminderProps = {
  section: CultivarSaveSection;
  hidden?: boolean;
};

const CultivarSaveReminder = ({ section, hidden = false }: CultivarSaveReminderProps) => {
  if (hidden) {
    return null;
  }

  return (
    <p className="tw-text-xs tw-text-muted-foreground tw-font-bold tw-italic">
      {SAVE_REMINDER_MESSAGES[section]}
    </p>
  );
};

export default CultivarSaveReminder;
